import React from "react"

export default function ResetButton({ id, name, label = "Reset", description, formGuid, displayOption }) {
  return (
    <input
      tabIndex={0}
      id={id}
      name={name}
      type="reset"
      value={label}
      className={`button button--reset button--medium Form__Element ${displayOption}`}
      data-f-element-nondata=""
      data-f-type="resetbutton"
      title={description}
      aria-label={description}
      form={formGuid}
    />
  )
}
